

export function getYearMonthDayUTC(date?: Date): {
    year: number;
    month: number;
    day: number;
} {
    const theDate = date ?? new Date();
    const year = theDate.getUTCFullYear();
    const month = theDate.getUTCMonth() + 1;
    const day = theDate.getUTCDate();
    return { year, month, day };
}


export function getYMD(date?: Date): number {
    const theDate = date ?? new Date();
    const year = theDate.getUTCFullYear();
    const month = theDate.getUTCMonth() + 1;
    const day = theDate.getUTCDate();
    return 10000 * year + 100 * month + day;
}
